import { ApiHttpError } from '@/shared/api/client';
import { z } from 'zod';
import {
  SOURCE_IMPORT_DUPLICATE_ID_ERROR,
  SOURCE_IMPORT_DUPLICATE_SOURCE_ERROR,
} from '../config/sourceImport';
import type { PreviousSourceImport } from '../types/uploads';

export type SourceImportCreateConflict = 'duplicate-id' | 'duplicate-source';

const SOURCE_IMPORT_CREATE_CONFLICTS: Record<string, SourceImportCreateConflict> = {
  [SOURCE_IMPORT_DUPLICATE_ID_ERROR]: 'duplicate-id',
  [SOURCE_IMPORT_DUPLICATE_SOURCE_ERROR]: 'duplicate-source',
};

export function sourceImportCreateConflict(error: unknown): SourceImportCreateConflict | undefined {
  if (!(error instanceof ApiHttpError) || error.status !== 409) return undefined;
  return SOURCE_IMPORT_CREATE_CONFLICTS[error.serverMessage];
}

const previousSourceImportSchema = z.object({
  importId: z.string().regex(/^im-[0-9a-f]{12}-[0-9]+$/),
  filename: z.string().min(1),
  projectId: z.string().min(1),
  relocatedByOperationId: z.string().nullable(),
  transferState: z.string(),
  mcapStatus: z.string().nullable(),
  intakeState: z.string().nullable(),
  failure: z.string().nullable(),
});

/** The 409 body is untyped; accept only the authorized original-record status shape. */
export function previousSourceImportFromConflict(error: unknown): PreviousSourceImport | undefined {
  if (sourceImportCreateConflict(error) !== 'duplicate-source') return undefined;
  const payload = error instanceof ApiHttpError ? error.payload : undefined;
  if (payload === null || typeof payload !== 'object' || !('existingImport' in payload))
    return undefined;
  const result = previousSourceImportSchema.safeParse(payload.existingImport);
  return result.success ? result.data : undefined;
}
